<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
      <div class="participant-banner" [ngClass]="participantClassByRole">
        <div class="container">
          <h2>{{'closePlanText'|translate:translations}}</h2>
        </div>
      </div>
      <div class="h-30"></div>
      <div class="container">
        <div class="plan-goals-heading open-plan-header">
          <span><img src="assets/plan-goals.svg" class="plan-goal-thumbnail"></span>
          <span class="w-10p"></span>
          <div class="closed-plan-header-content-div">
            <h2>{{closedPlanView.planName}}</h2>
            <span class="plan-date-and-reminder-div">
              <span><img src="assets/calendar.svg" class="reminder-bell pr-3">{{closedPlanView.whenAreYouGoingToDoIt}}</span>
              <span class="w-20p"></span>
              <span><img src="assets/reminder-bell.svg" class="reminder-bell pr-3"> {{closedPlanView.reminderFrequency}}</span>
            </span>
          </div>
        </div>
        <div class="h-30"></div>
        <div class="form-fields">
          <label id="label-appointment-length">{{'didYouTryToDoItText'|translate:translations}}</label>
          <mat-radio-group name="raddidyoutry" aria-labelledby="label-raaddinfomeetingstatus"
            class="intake-form-radio-group" [(ngModel)]="closePlanDetails.didYouTryToDoIt">
            <mat-radio-button name="radDidyoutrytodoit" class="intake-form-radio-button" [value]="true">
              {{'yesText'|translate:translations}}
            </mat-radio-button>
            <mat-radio-button name="radDidyoutrytodoit" class="intake-form-radio-button" [value]="false">
              {{'noText'|translate:translations}}
            </mat-radio-button>
          </mat-radio-group>

        </div>
        <div class="mb-10"></div>
        <div id="didyoutryitYesPanel" [hidden]="!closePlanDetails.didYouTryToDoIt">
          <div class="form-fields">
            <mat-label>{{'wentWellText'|translate:translations}}</mat-label>
            <mat-form-field appearance="outline" floatLabel="always">
              <textarea matInput class="form-control-textbox" [(ngModel)]="closePlanDetails.wentWellAndNotSoWell"
                name="whatwentwell" [cols]="colNums" [rows]="rowNums"></textarea>
            </mat-form-field>
          </div>
          <div class="mb-10"></div>

          <div class="form-fields">
            <mat-label>{{'learnedFromWhatHappenedText'|translate:translations}}?</mat-label>
            <mat-form-field appearance="outline" floatLabel="always">
              <textarea matInput class="form-control-textbox" [(ngModel)]="closePlanDetails.learnedFromWhatHappened"
                name="learnedFromWhatHappened" [cols]="colNums" [rows]="rowNums"></textarea>
            </mat-form-field>
          </div>
          <div class="mb-10"></div>
        </div>

        <div id="didyoutryitNoPanel" [hidden]="closePlanDetails.didYouTryToDoIt">
          <span>{{'stoppedYouText'|translate:translations}}?</span>
          <div class="h-30"></div>
          <div class="form-fields">
            <mat-label> {{'internalThingsText'|translate:translations}}</mat-label>
            <mat-form-field appearance="outline" floatLabel="always">
              <textarea matInput class="form-control-textbox"
                [(ngModel)]="closePlanDetails.whatStoppedYouInternalThings" name="whatStoppedYouInternalThings"
                [cols]="colNums" [rows]="rowNums"></textarea>
            </mat-form-field>
          </div>
          <div class="mb-10"></div>

          <div class="form-fields">
            <mat-label>{{'externalThingsText'|translate:translations}}</mat-label>
            <mat-form-field appearance="outline" floatLabel="always">
              <textarea matInput class="form-control-textbox"
                [(ngModel)]="closePlanDetails.whatStoppedYouExternalThings" name="whatStoppedYouExternalThings"
                [cols]="colNums" [rows]="rowNums"></textarea>
            </mat-form-field>
          </div>
          <div class="mb-10"></div>

          <div class="form-fields">
            <mat-label>{{'plannedText'|translate:translations}}</mat-label>
            <mat-form-field appearance="outline" floatLabel="always">
              <textarea matInput class="form-control-textbox"
                [(ngModel)]="closePlanDetails.plannedToDealWithTheseThings" name="plannedToDealWithTheseThings"
                [cols]="colNums" [rows]="rowNums"></textarea>
            </mat-form-field>
          </div>
          <div class="mb-10"></div>
        </div>
      </div>
      <div class="h-30"></div>
      <div class="form-buttons">
        <button class="submit-form-button" (click)="onClosePlanClick()" [ngClass]="participantClassByRole">{{'submitButtonText'|translate:translations}}</button>
        <a href="/dashboard-participant" class="submit-form-button cancel-button">{{'cancelButtonText'|translate:translations}}</a>
      </div>
    </div>
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>
